import Select from 'shopper/components/Select';
import Text from 'shopper/components/Text';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import { useCommentsRoot } from '../Root';

import COMMENT from 'constants/comment';

const SORT_LABELS = {
  BY_OLDER: 'Mais antigos',
  BY_LATEST: 'Mais recentes',
  BY_RELEVANCE: 'Mais relevantes',
};

const Sort = () => {
  const { commentsSort, gaEventCategory, setCommentsSort } = useCommentsRoot();

  const onSelectHandler = ({ target }) => {
    const sort = target.value;

    sendEvent({
      action: `sort_comment_${sort}`,
      category: gaEventCategory,
    });
    setCommentsSort(sort);
  };

  return (
    <div className="flex items-center">
      <Text
        as="label"
        className="text-nowrap md:inline-block"
        htmlFor="select_offer-comments-order"
        size="size3"
      >{`${placeholder('subtitles.sortBy')}`}</Text>
      <Select
        className="ml-1"
        id="select_offer-comments-order"
        options={[
          {
            label: SORT_LABELS.BY_RELEVANCE,
            value: COMMENT.SORT_VALUES.RELEVANCE,
            isSelected: commentsSort === COMMENT.SORT_VALUES.RELEVANCE,
          },
          {
            label: SORT_LABELS.BY_LATEST,
            value: COMMENT.SORT_VALUES.LATEST,
            isSelected: commentsSort === COMMENT.SORT_VALUES.LATEST,
          },
          {
            label: SORT_LABELS.BY_OLDER,
            value: COMMENT.SORT_VALUES.OLDEST,
            isSelected: commentsSort === COMMENT.SORT_VALUES.OLDEST,
          },
        ]}
        selectClassName="border-none text-sm font-bold lg:text-sm dark:bg-neutral-low-500"
        selectWrapperClassName="border-none"
        onChange={onSelectHandler}
      />
    </div>
  );
};

export default Sort;
